/**
 * Tipos da tela Configuração → Times & Roteamento (Item 366 Fase 4).
 *
 * Hand-written, espelham os contratos do engine:
 *   - /v1/team-configs (TeamView + membership) — caps team-config-read/manage.
 *   - /v1/routing-rules (RoutingRuleDto) — cap playbook-author.
 * `version` sempre presente em GET de Team (If-Match no PATCH/DELETE, ADR-071).
 */

export type RoutingStrategy = 'round_robin' | 'least_loaded' | 'skills_weighted' | 'fixed_route';
export type TeamRole = 'member' | 'lead';

/**
 * Fatia D1 (Item 386) — especialidade de área do time. O roteamento PREFERE o
 * time cuja área casa com o vertical do playbook resolvido. Espelha o enum
 * Prisma `TeamArea` / `@lume/shared` TEAM_AREAS.
 */
export type TeamArea =
  | 'support'
  | 'commercial'
  | 'financial'
  | 'retention'
  | 'legal'
  | 'healthcare'
  | 'general';

export interface TeamMemberView {
  userId: string;
  name: string;
  roleInTeam: TeamRole;
  isPrimary: boolean;
}

export interface TeamView {
  id: string;
  tenantId: string;
  name: string;
  slug: string;
  description: string | null;
  routingStrategy: RoutingStrategy | null;
  area: TeamArea | null;
  active: boolean;
  version: number;
  memberCount: number;
  members: TeamMemberView[];
  createdAt: string;
  updatedAt: string | null;
}

export interface CreateTeamBody {
  name: string;
  slug?: string;
  description?: string;
  routingStrategy?: RoutingStrategy;
  area?: TeamArea;
}

export interface UpdateTeamBody {
  name?: string;
  description?: string | null;
  routingStrategy?: RoutingStrategy | null;
  area?: TeamArea | null;
  active?: boolean;
}

export interface AddMemberBody {
  userId: string;
  roleInTeam?: TeamRole;
  isPrimary?: boolean;
}

export interface UpdateMemberBody {
  roleInTeam?: TeamRole;
  isPrimary?: boolean;
}

/** Regra de roteamento (subset consumido pela tela — conditions é Json livre). */
export interface RoutingRuleDto {
  id: string;
  tenantId: string;
  name: string;
  priority: number;
  conditions: Record<string, unknown>;
  decisionTargetTeamId: string | null;
  decisionPlaybookId: string | null;
  isActive: boolean;
  version: number;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface CreateRoutingRuleBody {
  name: string;
  priority: number;
  conditions: Record<string, unknown>;
  decisionTargetTeamId?: string;
  decisionPlaybookId?: string;
  isActive?: boolean;
}

export const ROUTING_STRATEGY_LABELS: Record<RoutingStrategy, string> = {
  round_robin: 'Rodízio (round-robin)',
  least_loaded: 'Menor carga',
  skills_weighted: 'Por habilidades',
  fixed_route: 'Rota fixa',
};

/** Fatia D1 — rótulos PT-BR das áreas de time (tela Times & Roteamento). */
export const TEAM_AREA_LABELS: Record<TeamArea, string> = {
  support: 'Suporte',
  commercial: 'Comercial',
  financial: 'Financeiro',
  retention: 'Retenção',
  legal: 'Jurídico',
  healthcare: 'Saúde',
  general: 'Geral',
};
